import { flattenLearningPathBundle } from "./flattenLearningPathBundle";
import {
  LearningPathParseError,
  parseLearningPathBundle,
} from "./parseLearningPathBundle";
import type { FlattenedLearningPath, LearningPathGraphIssue } from "./types";
import { validateLearningPathGraph } from "./validateLearningPathGraph";

export type PrepareLearningPathImportResult =
  | { ok: true; flattened: FlattenedLearningPath }
  | { ok: false; parseError: string }
  | { ok: false; issues: LearningPathGraphIssue[] };

export function prepareLearningPathImport(
  text: string
): PrepareLearningPathImportResult {
  let bundle;
  try {
    bundle = parseLearningPathBundle(text);
  } catch (error: unknown) {
    const parseError =
      error instanceof LearningPathParseError
        ? error.message
        : error instanceof Error
          ? error.message
          : "Invalid JSON.";
    return { ok: false, parseError };
  }

  const { flattened, issues: flattenIssues } =
    flattenLearningPathBundle(bundle);
  const issues = [...flattenIssues, ...validateLearningPathGraph(flattened)];
  if (issues.length > 0) {
    return { ok: false, issues };
  }
  return { ok: true, flattened };
}
